// extracted by mini-css-extract-plugin
export default {"base":"LineChartDisplay_base__dEclG","select":"LineChartDisplay_select__2R57d"};